import { ModalStore } from 'ui/base/modal/modal_store';
import { BooleanStore } from 'ui/base/input';
import { action, computed, observable } from 'mobx';
import { ORDERED_WEEKDAYS, Weekday } from 'assets/enums/weekdays/weekdays';

export class WeekdayStore {
  @observable.deep values: Record<Weekday, boolean>;
  workspace: Record<Weekday, BooleanStore>;

  modal: ModalStore;

  constructor(initial: Record<Weekday, boolean>) {
    this.values = {
      [Weekday.MONDAY]: initial[Weekday.MONDAY],
      [Weekday.TUESDAY]: initial[Weekday.TUESDAY],
      [Weekday.WEDNESDAY]: initial[Weekday.WEDNESDAY],
      [Weekday.THURSDAY]: initial[Weekday.THURSDAY],
      [Weekday.FRIDAY]: initial[Weekday.FRIDAY],
      [Weekday.SATURDAY]: initial[Weekday.SATURDAY],
      [Weekday.SUNDAY]: initial[Weekday.SUNDAY],
    };

    this.workspace = {
      [Weekday.MONDAY]: new BooleanStore(this.values[Weekday.MONDAY]),
      [Weekday.TUESDAY]: new BooleanStore(this.values[Weekday.TUESDAY]),
      [Weekday.WEDNESDAY]: new BooleanStore(this.values[Weekday.WEDNESDAY]),
      [Weekday.THURSDAY]: new BooleanStore(this.values[Weekday.THURSDAY]),
      [Weekday.FRIDAY]: new BooleanStore(this.values[Weekday.FRIDAY]),
      [Weekday.SATURDAY]: new BooleanStore(this.values[Weekday.SATURDAY]),
      [Weekday.SUNDAY]: new BooleanStore(this.values[Weekday.SUNDAY]),
    };

    this.modal = new ModalStore(false);
  }

  // This triggers a reload from the stored values to the workspace
  // This is best used before opening the modal
  @action.bound
  reloadWorkspace(): void {
    Object.entries(this.workspace).forEach(([day, store]) => {
      store.value = this.values[day as Weekday];
    });
  }

  // This triggers a commit to the workspace from the stored values
  // Best used before closing and saving the modal
  @action.bound
  commitWorkspace(): void {
    Object.entries(this.workspace).forEach(([day, store]) => {
      this.values[day as Weekday] = store.value;
    });
  }

  @computed get arrayValue(): Weekday[] {
    return ORDERED_WEEKDAYS.filter((day) => this.values[day] === true);
  }

  @computed get workspaceHasChecked(): boolean {
    return Object.values(this.workspace).some((store) => store.value);
  }
}
